import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { v4 as uuidv4 } from 'uuid';

window.PDFJS = pdfjsLib;
//pdfjs.GlobalWorkerOptions.workerSrc = `/static/pdf.worker.min.js`;
/**
 * @param  {Object} page
 * @param  {Number} size
 * @return {String}
 */

const makeThumbnail = (page, size) => {
  // draw page to fit into input size canvas
  const desiredWidth = size;
  const viewPort = page.getViewport({ scale: 1 });

  const scale = desiredWidth / viewPort.width;
  const scaledViewport = page.getViewport({ scale: scale });

  const canvas = document.createElement('canvas');
  canvas.height = scaledViewport.height;
  canvas.width = scaledViewport.width;

  return page
    .render({
      canvasContext: canvas.getContext('2d', { willReadFrequently: true }),
      viewport: scaledViewport
    })
    .promise.then(function () {
      return canvas.toDataURL();
    });
};

/**
 * @param  {String} source
 * @param  {Number} size
 * @return {Array}
 */
export const generatePdfThumbnails = async (source, size, fileId, fileName) => {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
  if (!pdfjsLib.getDocument) {
    // eslint-disable-next-line no-alert
    alert('Please build the pdfjs-dist library using\n  `gulp dist-install`');
  }

  const pdfDocument = await pdfjsLib.getDocument(source).promise;
  const pages = [];
  while (pages.length < pdfDocument.numPages) pages.push(pages.length + 1);

  const t = Promise.all(
    pages.map(num =>
      pdfDocument
        .getPage(num)
        .then(page => makeThumbnail(page, size))
        .then(thumbnail => ({
          fileId,
          fileName,
          page: num,
          thumbnail,
          storageKey: uuidv4()
        }))
    )
  );

  return t;
};

export default generatePdfThumbnails;
